import * as toastr from "toastr";

export function logServerError(error) {
  let message = error.message;
  if (error.response) {
    message = error.response.data.message;
  }
  toastr.error(message);
}
